module.exports = __webpack_public_path__ + "img/auditReview.ca8c74c3.svg";